import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const LandlordDropdown = ({ merchantIds, setSelectedLandlords, ...props }) => {
  const { accessToken } = useAuth()

  const [landlords, setLandlords] = useState([]);
  useEffect(() => {
    async function getLandlords() {
      const url = new URL('/api/landlord', window.location);
      url.searchParams.append('mode', 'dropdown')
      if (merchantIds)
        for (const merchantId of merchantIds)
          url.searchParams.append('merchantId', merchantId)

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      })
      if (res.ok) {
        const { landlords } = await res.json()
        setLandlords(landlords)
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getLandlords()
  }, [accessToken, merchantIds]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Site Name"
      maxTagCount="responsive"
      maxTagPlaceholder={(ids) => `+ ${ids.length}`}
      optionFilterProp="children"
    >
      {setSelectedLandlords && (
        <div disabled={true}>
          <span
            onClick={() => setSelectedLandlords(landlords.map(landlord => landlord.id))}
            style={{
              display: "inline-block",
              color: "#286FBE",
              cursor: "pointer",
            }}
          >
            SELECT ALL
          </span>
        </div>
      )}
      {landlords.map(landlord => (
        <Select.Option key={landlord.id} value={landlord.id}>
          {landlord.nameEn}
        </Select.Option>
      ))}
    </Select>
  );
};

export default LandlordDropdown;
